<template>
  <v-container fluid grid-list-xl style="overflow-y: auto">
    <EditNetworkDialog ref="editDialog" />

    <div class="w-full d-flex">
      <OCapCont class="w-1/3 pa-3" label="Nome" :value="row.name" />
      <OCapCont class="w-1/3 pa-3" label="SSID" :value="row.ssid" />
      <OCapCont class="w-1/3 pa-3" label="Senha" :value="row.pass" />
    </div>
    <OCapCont class="w-full pa-2" label="Tags">
      <OTagList :value="row.tags" />
    </OCapCont>

    <OCapCont
      class="w-full pa-3"
      label="Observações"
      :value="row.comments || '─'"
    />

    <div class="w-full d-flex">
      <OCapCont
        class="w-1/3 pa-3"
        label="Recebido de"
        :value="row.receivedFrom || '─'"
      />

      <OCapCont
        class="w-1/3 pa-3"
        label="Recebido por"
        :value="row.receivedBy || '─'"
      />

      <OCapCont
        class="w-1/3 pa-3"
        label="Recebido em"
        :value="row.receivedAt || '─'"
      />
    </div>
    <div class="pa-3 mt-8">
      <v-btn large color="primary" @click="edit">Editar Informações</v-btn>
    </div>
  </v-container>
</template>

<script>
import EditNetworkDialog from './EditNetworkDialog.vue'
export default {
  components: { EditNetworkDialog },
  tabTitle: 'Geral',
  computed: {
    // apenas renomeia "value", que é injetado pelo TabbedInterface,
    // para "row", que é o padrão em várias outras telas.
    row() {
      return this.value
    }
  },
  props: {
    value: { required: true }
  },
  methods: {
    async edit() {
      await this.$refs.editDialog.open(this.value.id)
      this.$emit('reload')
    }
  }
}
</script>

<style></style>
